import * as _ from "lodash";
import {action, observable} from "mobx";
import IReportingFilterHandler from '../interfaces/IReportingFilterHandler';
import IDictionary from '../../interfaces/IDictionary';
import IReportingFilter from '../../../modules/reporting/common/interfaces/IReportingFilter';

export default class BaseFilter<T = any> implements IReportingFilterHandler<T> {

	public type;
	@observable public isLoading: boolean;
	@observable public items: T[];
	public valueKey: string;
	public labelKey: string;
	public allowNew: boolean;
	protected initialized: boolean;
	private valueByLabel: IDictionary<any>;
	private labelByValue: IDictionary<any>;
	private indexedItems: T[];

	constructor() {
		this.reset();
	}

	private reset() {
		this.items = [];
		this.valueKey = "";
		this.labelKey = "";
		this.valueByLabel = null;
		this.labelByValue = null;
		this.allowNew = true;
		this.initialized = false;
	}

	public initialize(): Promise<any> {
		this.isLoading = false;
		this.initialized = true;

		return Promise.resolve();
	}

	public getValueByLabel(label: string): any {
		if (this.valueKey && this.labelKey) {
			if (!this.valueByLabel || this.indexedItems !== this.items) {
				this.indexItems();
			}

			return this.valueByLabel[label];
		}

		return label;
	}

	public getLabelByValue(value: string): any {
		if (this.valueKey && this.labelKey) {
			if (!this.labelByValue || this.indexedItems !== this.items) {
				this.indexItems();
			}

			return this.labelByValue[value];
		}

		return value;
	}

	// Rebuilt whenever the list is replaced, so a lookup made before the data loaded does not stick.
	private indexItems() {
		this.indexedItems = this.items;
		this.valueByLabel = {};
		this.labelByValue = {};

		_.forEach(this.items, (item) => {
			this.valueByLabel[item[this.labelKey]] = item[this.valueKey];
			this.labelByValue[item[this.valueKey]] = item[this.labelKey];
		});
	}

	public reportify(filter: IReportingFilter): { key: string; exclude: boolean; values: string[]; operator: string; } | null {
		const values = _.compact(filter.values);

		if (values.length) {
			return {
				key: filter.key,
				exclude: filter.exclude,
				operator: filter.operator,
				values: _.map(values, (value: any) => _.isObject(value) ? value[this.valueKey] : value)
			};
		}

		return null;
	}
}
